// extracted by mini-css-extract-plugin
module.exports = {"balloonIllustrationWrapper":"balloonIllustration-module--balloonIllustrationWrapper--3i4ji"};